<app-header></app-header>

<div class="full-height container-fluid">
    <div class="row d-flex justify-content-center align-items-center my-4 py-4">
        <div class="col-xs-10 col-md-5 col-lg-5 col-md-offset-1">
            <h3 class="header">Hi <span class="font-bold">{{invitationDetails?.inviteeName}},
                {{invitationDetails?.invitedByName}}</span> has invited you to become an <span
                    class="font-bold">investor</span> on
                finzy</h3>
            <h5 class="subheading">Finzy is India's premier peer to peer lending platform. We digitally connect
                investors to
                hand-picked borrowers to provide risk optimised returns. You can easily onboard with us by reviewing the
                pre-filled information from your invitation. We just need a quick verification to identify you.</h5>

            <div class="row" *ngIf="isPanVerified">
                <div *ngIf="showMobileOTP">
                    <div class="verification-container col-xs-12">
                        <h3>Verify your Identity</h3>
                        <div class="d-flex align-items-center verification-content">
                            <div class="check"></div>
                            <h5 class="verification-item mr-4 pr-4">Verify PAN Card</h5>
                            <div class="d-flex align-items-center justify-content-center list-item">b</div>
                            <h5 class="active-item">Verify Mobile Number</h5>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-10 col-lg-10 mt-3">
                        <app-consent-otp (otpEntered)="otpEntered($event)"
                                         (otpRequest)="requestPhoneOtp()"
                                         [editDisabled]="invitationDetails?.inviteePhoneNumber.length>0"
                                         [inputValue]="invitationDetails?.inviteePhoneNumber"></app-consent-otp>
                    </div>
                    <div class="col-xs-12">
                        <small *ngIf="errorMessage " [hidden]='isLoadingInProgress'
                               class="text-error">{{errorMessage}}</small>
                    </div>
                </div>
                <div *ngIf="showConsent" class="col-xs-12 terms-and-conditions mt-3">
                    <label class="d-flex">
                        <input type="checkbox" class="mr-2" (change)="enableSubmitButton()"
                               [(ngModel)]="readOnlyTermsAccepted">
                        <span class="terms-text">By clicking on continue you will be giving a confirmation to associate you to {{invitationDetails?.invitedByName}}
                            and provide read-only-access to a summary of your Loan Under Management (LUM).</span>
                    </label>
                    <label class="d-flex m-0"><input type="checkbox" class="mr-2"
                                                     (change)="enableSubmitButton()"
                                                     [(ngModel)]="termsAccepted">

                        <span class="terms-text">I agree to the <a target="_blank" class="terms"
                                                                   href="https://finzy.com/terms">Terms and Conditions</a></span></label>
                </div>

                <div class="col-xs-12">
                    <div class="row d-flex justify-content-between mt-4">
                        <div class="mb-2"></div>
                        <div>
                            <button mat-flat-button color="primary" type="submit" [disabled]="!isPhoneVerified"
                                    (click)="onSubmit()" *ngIf="!isLoadingInProgress">
                                Verify and Continue
                            </button>
                            <mat-spinner *ngIf="isLoadingInProgress" [diameter]="35"></mat-spinner>
                        </div>
                    </div>
                </div>
            </div>

            <app-pan-verification *ngIf="!isPanVerified && !isUserExists" [pan]="invitationDetails.inviteePan"
                                  (panVerified)="onPanVerified($event)" [inviteeName]="invitationDetails.inviteeName"
                                  [invitedByName]="invitationDetails.invitedByName"
                                  [panVerificationResult]="panVerificationResult"></app-pan-verification>
        </div>

        <div class="col-xs-12 col-md-5 col-lg-4 col-md-offset-1 mt-4">
            <div class="why-finzy-container">
                <div class="why-finzy-header px-3 px-lg-4">
                    <h3>Why Finzy</h3>
                    <ul class="why-finzy-list">
                        <li class="why-finzy-item">A new regular return asset class</li>
                        <li class="why-finzy-item">Multiply your revenues with finzy</li>
                        <li class="why-finzy-item">Diversified investments</li>
                        <li class="why-finzy-item">No registration fee. No processing fee</li>
                    </ul>
                    <div class="partner-us-section px-4 py-3">
                        <h5 class="partner-us-content"><span class="opacity">For more information please visit </span>
                            <a class="link" target="_blank" href="https://finzy.com">www.finzy.com</a>
                        </h5>
                        <h5 class="partner-us-content mt-1 mb-0"><span
                                class="opacity">Get in touch with us at </span>support@finzy.com
                            or 9341 300 300</h5>
                    </div>
                </div>
                <div class="why-finzy-header px-3 px-lg-4">
                    <h3>Quick steps to get started</h3>
                    <ul class="onboard-list">
                        <li class="why-finzy-item">
                            <span class="onboard-active-pointer">1</span>
                            Verify your Identity (You are here now)
                        </li>
                        <li class="why-finzy-item">
                            <span class="onboard-pointer">2</span>
                            Review and edit filled info
                        </li>
                        <li class="why-finzy-item">
                            <span class="onboard-pointer">3</span>
                            Submit and Start investing
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
